import moment from "moment"
import { CarrotPlan } from "types/CarrotPlan"
import { RoutingInfo } from "types/RoutingInfo"

type RoutingInfoWithCompletedDate = {
  date: moment.Moment
  routingInfo: RoutingInfo
}

export type UseMatchCarrotPlanToRoutingInfo = RoutingInfo | null

export const getMatchingRoutingInfoForCarrotPlan = ({
  carrotPlan,
  mostRecentRoutingInfo,
  pastRoutingInfo = []
}: {
  carrotPlan: CarrotPlan
  mostRecentRoutingInfo: RoutingInfo
  pastRoutingInfo?: RoutingInfo[]
}): UseMatchCarrotPlanToRoutingInfo => {
  if (!carrotPlan || !mostRecentRoutingInfo) return null

  if (pastRoutingInfo.length === 0) {
    return mostRecentRoutingInfo
  }

  const carrotPlanCreatedDate = moment(carrotPlan?.createdAtUtc)

  // Initialize the accumulator with placeholder values
  const initialAccumulator: RoutingInfoWithCompletedDate = {
    date: moment(0),
    routingInfo: {} as RoutingInfo
  }

  // Use reduce to find the routingInfo with the latest date before or on the carrotPlanCreatedDate
  const matchingRoutingInfo: RoutingInfoWithCompletedDate = [mostRecentRoutingInfo, ...pastRoutingInfo].reduce(
    (acc, routingInfo) => {
      const routingCompletedDate = moment(routingInfo?.routingCompletedDate)
      if (!routingCompletedDate) return acc

      if (routingCompletedDate.isSameOrBefore(carrotPlanCreatedDate) && routingCompletedDate.isAfter(acc.date)) {
        return { date: routingCompletedDate, routingInfo: routingInfo }
      }

      return acc
    },
    initialAccumulator
  )

  return matchingRoutingInfo?.routingInfo
}
